'use client';

import React from 'react';
import z from 'zod';
import { SxProps } from '@unity/cloud-ui/styles';
import { getComponentDocumentationUrl } from '@/utils/get-component-doc-url';
import CodeWrapper from './code-wrapper';

interface CodeGroupProps extends z.input<typeof codeGroupSchema> {
  sxOverride?: SxProps;
}

export const CodeGroup = ({ children, sxOverride }: CodeGroupProps) => {
  const codeBlocks = React.Children.map(children, (child) => ({
    title: child.props.title,
    language: child.props.children.props.className?.split('-').pop() ?? '',
    code: child.props.children.props.children,
  }));

  return <CodeWrapper codeBlocks={codeBlocks} sxOverride={sxOverride} />;
};

const documentationUrl = getComponentDocumentationUrl('code-blocks');

const descriptions = {
  children: 'The content of the code group.',
  schema: `Groups code snippets in tabs for better organization.
      
  **Example**
  \`\`\`mdx
  <CodeGroup>

  \`\`\`javascript title="helloWorld.js"
  console.log("Hello World");


  \`\`\`python title="hello_world.py"
  print('Hello World!')

  </CodeGroup>
  \`\`\`

  ${documentationUrl}`,
};

export const codeGroupSchema = z
  .object({
    children: z.any().describe(descriptions.children),
  })
  .describe(descriptions.schema);

export default CodeGroup;
